import { axios } from 'libs/axios';
import { useMutation, MutationConfig, queryClient } from 'libs/react-query';

export const updateUserLogin = (): Promise<void> => {
  return axios.post('care/update-user-login/');
};
